import copy from 'fast-copy';
import safeCompare from '~/helpers/safeCompare';
import { checkFullyVisible, isMatchingRegExp } from '~/utils/NodeMatcherTyped';

const isMatchingChildNodes = (nodeList, ruleItem) => {
  for (let i = 0; i < nodeList.length; i++) {
    if (isMatchingCondition(ruleItem, nodeList[i])) {
      return true;
    }
  }

  return false;
};

export const isMatchingCondition = (node, ruleItem) => {
  const nodeWithRulesObjects = [
    {
      node,
      ruleItem: copy(ruleItem),
    },
  ];

  while (nodeWithRulesObjects.length > 0) {
    const nodeWithRulesObject = nodeWithRulesObjects.pop();
    const currentNode = nodeWithRulesObject.node;
    const rules = nodeWithRulesObject.ruleItem;

    if (currentNode === null || typeof currentNode === 'undefined') {
      return false;
    }

    for (const name in rules) {
      if (rules.hasOwnProperty(name)) {
        const rule = rules[name];
        const propertyValue = currentNode[name];
        const stringCondition = typeof rule === 'string';
        const complexCondition = typeof rule === 'object';
        const hasStringProperty = typeof propertyValue === 'string';

        if (name === 'onScreen') {
          const result = rule === checkFullyVisible(currentNode);
          if (!result) {
            return false;
          }
        } else if (propertyValue === null) {
          return false;
        } else if (stringCondition && hasStringProperty) {
          // String condition
          if (rule.startsWith('{{') && rule.endsWith('}}')) {
            // check {{regexp}} (совпадение с regexp)
            return new RegExp(rule.substr(2, rule.length - 4)).test(propertyValue);
          }

          return false;
          // Object condition
        } else if (complexCondition) {
          if (name === 'dataset') {
            nodeWithRulesObjects.push({ node: propertyValue, ruleItem: rule });
          } else if (name === 'parentNode') {
            const level = rule.level ? rule.level : 0;
            let parentValue = propertyValue;
            for (let i = 0; i < level; i++) {
              if (parentValue.parentNode) {
                parentValue = parentValue.parentNode;
              } else {
                break;
              }
            }
            delete rule.level;
            nodeWithRulesObjects.push({ node: parentValue, ruleItem: rule });
          }
          if (name === 'computedStyle') {
            const computedStyle = getComputedStyle(currentNode);
            const computedStylesObject = {};
            Object.keys(rule).forEach((key) => {
              computedStylesObject[key] = computedStyle[key];
            });
            nodeWithRulesObjects.push({
              node: computedStylesObject,
              ruleItem: rule,
            });
          } else if (name === 'childNode') {
            return !isMatchingChildNodes(node.childNodes, rule);
          } else if (name === 'regExp') {
            return !isMatchingRegExp(node, rule);
          } else if (name === 'ownerDocument') {
            nodeWithRulesObjects.push({ node: propertyValue, ruleItem: rule });
          }
          // Boolean, number, etc. condition
        } else {
          if (!safeCompare(rule, propertyValue)) return false;
        }
      }
    }
  }

  return true;
};

export const findMatchingRulesForNode = (node, settings) =>
  Object.entries(settings)
    .filter(([, rules]) =>
      rules.some((rule) => {
        return isMatchingCondition(node, rule);
      })
    )
    .map(([key]) => key);

export const findMatchingRulesForTree = (node, settings, result) => {
  if (typeof settings === 'undefined') {
    return [];
  }
  const rules = findMatchingRulesForNode(node, settings);
  if (rules.length > 0) {
    if (result) result.node = node;

    return rules;
  }
  if (node.parentNode) {
    return findMatchingRulesForTree(node.parentNode, settings, result);
  }

  return [];
};
